/*
 * @Author: 厂言
 * @Date: 2022-03-11 15:10:01
 * @LastEditTime: 2022-03-19 18:30:24
 * @LastEditors: 厂言
 * @Description: 接口请求
 */
import request from '../../api'
import request_ from '../../api/index_'
let requestFormAjax = request.requestFormAjax
let requestAjax= request.requestAjax
let requestFormAjax_ = request_.requestFormAjax
let requestAjax_ = request_.requestAjax

export const getHistoryToday = params => {  // 获取历史上的今天
  return requestAjax({
    url: '/history/today',
    params,
    method: 'post',
    ourl: '/mujs-pias-app'
  })
}

export const getIntegralRecordList = (params) => {
  return requestFormAjax({
    url: '/flight/getMujsDmpDingIntegralBizList',
    params,
    method: 'post',
    ourl: '/mujs-pias-app'
  })
}

export const getMujsDmpDingIntegralBizOfSafeList = (params) => {
  return requestFormAjax({
    url: '/flight/getMujsDmpDingIntegralBizOfSafeList',
    params,
    method: 'post',
    ourl: '/mujs-pias-app'
  })
}

export const getMujsDmpDingIntegralBizOfRunList = (params) => {
  return requestFormAjax({
    url: '/flight/getMujsDmpDingIntegralBizOfRunList',
    params,
    method: 'post',
    ourl: '/mujs-pias-app'
  })
}

export const getLineChart = (params) => {
  return requestAjax({
    url: '/flight/monthlychangepoints',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const monthlychangepointsOfSafe = (params) => {
  return requestAjax({
    url: '/flight/monthlychangepointsOfSafe',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const monthlychangepointsOfRun = (params) => {
  return requestAjax({
    url: '/flight/monthlychangepointsOfRun',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const getRadarChart = (params) => {
  return requestAjax({
    url: '/flight/getradarmap',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const getradarmapOfSafe = (params) => {
  return requestAjax({
    url: '/flight/getradarmapOfSafe',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const getTotalPie = (params) => {
  return requestAjax({
    url: '/flight/Proportion',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const getIntegralChangeDetail = (params) => {
  return requestAjax({
    url: '/flight/getintegralbizdetail',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const getDepartList = (params) => {
  return requestAjax({
    url: '/flight/departList',
    params,
    method: 'post',
    ourl: '/mujs-pias-app'
  })
}

export const getCategoryData = (params) => {
  return requestAjax({
    url: '/MujsApp/biz/getHistogram',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const getMemberList = (params) => {
  return requestAjax({
    url: '/flight/get/dept/member/list',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const getDeptHeader = (params) => {
  return requestAjax({
    url: '/flight/head',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const getPersonalHeader = (params) => {
  return requestAjax({
    url: '/flight/get/user/info/head',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const getDeptTypePie = params => {
  return requestAjax({
    url: '/MujsApp/biz/getChart',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const getDeptTypeDetailPie = params => {
  return requestAjax({
    url: '/MujsApp/biz/getChartItem',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const getPersonalSafetyAndOperateIntegral = (url, params) => {
  return requestAjax({
    url: `/flight/piechart/${url}`,
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const deptIntegralDetailList = params => {  // 部门分数变化列表
  return requestFormAjax({
    url: `/flight/getdeptbizdetails`,
    params,
    method: 'post',
    ourl: '/mujs-pias-app'
  })
}

export const deptIntegralDetailTotal = params => {
  return requestAjax({
    url: `/flight/eventcontentlist`,
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const deptTimesDetailList = params => {  // 部门次数变化列表
  return requestFormAjax({
    url: `/flight/getdeptbiznum`,
    params,
    method: 'post',
    ourl: '/mujs-pias-app'
  })
}

export const deptTimesDetailTotal = params => {
  return requestAjax({
    url: `/flight/getCount`,
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const getDictionary = params => {  // 获取字典值接口
  return requestAjax({
    url: '/blade-system/dict-biz/dictionary',
    params,
    method: 'get',
    ourl: ''
  })
}

export const cadrePie = params => {
  return requestAjax({
    url: '/MujsApp/biz/headQuarters',
    params,
    method: 'get',
    ourl: '/mujs-pias-app'
  })
}

export const getLeaderList = params => {
  return requestAjax({
    url: '/flight/leaderlist',
    params,
    method: 'post',
    ourl: '/mujs-pias-app'
  })
}

export const getLeaderIntegralCountList = params => {  // 干部积分统计分类列表
  return requestAjax({
    url: '/flight/pointstypelist',
    params,
    method: 'post',
    ourl: '/mujs-pias-app'
  })
}

export const getLeaderIntegralCountDetail = params => {
  return requestAjax({
    url: '/flight/smallTypeList',
    params,
    method: 'post',
    ourl: '/mujs-pias-app'
  })
}

export const loginByDing = params => {
  return requestFormAjax_({
    url: '/blade-auth/oauth/token',
    method: 'post',
    params,
    ourl: ''
  })
}
